import { render, staticRenderFns } from "./historyInstall.vue?vue&type=template&id=8175b888&"
import script from "./historyInstall.vue?vue&type=script&lang=js&"
export * from "./historyInstall.vue?vue&type=script&lang=js&"
import style0 from "./historyInstall.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports